import type { Departement } from '../types';

export const DEPARTEMENTS: Departement[] = [
  {
    "id_departement": 1,
    "num_departement": "01",
    "nom_departement": "Ain",
    "full_departement": "01 | Ain"
  },
  {
    "id_departement": 2,
    "num_departement": "02",
    "nom_departement": "Aisne",
    "full_departement": "02 | Aisne"
  },
  {
    "id_departement": 3,
    "num_departement": "03",
    "nom_departement": "Allier",
    "full_departement": "03 | Allier"
  },
  {
    "id_departement": 4,
    "num_departement": "04",
    "nom_departement": "Alpes-de-Haute-Provence",
    "full_departement": "04 | Alpes-de-Haute-Provence"
  },
  {
    "id_departement": 5,
    "num_departement": "05",
    "nom_departement": "Hautes-Alpes",
    "full_departement": "05 | Hautes-Alpes"
  },
  {
    "id_departement": 6,
    "num_departement": "06",
    "nom_departement": "Alpes-Maritimes",
    "full_departement": "06 | Alpes-Maritimes"
  },
  {
    "id_departement": 7,
    "num_departement": "07",
    "nom_departement": "Ardèche",
    "full_departement": "07 | Ardèche"
  },
  {
    "id_departement": 8,
    "num_departement": "08",
    "nom_departement": "Ardennes",
    "full_departement": "08 | Ardennes"
  },
  {
    "id_departement": 9,
    "num_departement": "09",
    "nom_departement": "Ariège",
    "full_departement": "09 | Ariège"
  },
  {
    "id_departement": 10,
    "num_departement": "10",
    "nom_departement": "Aube",
    "full_departement": "10 | Aube"
  },
  {
    "id_departement": 11,
    "num_departement": "11",
    "nom_departement": "Aude",
    "full_departement": "11 | Aude"
  },
  {
    "id_departement": 12,
    "num_departement": "12",
    "nom_departement": "Aveyron",
    "full_departement": "12 | Aveyron"
  },
  {
    "id_departement": 13,
    "num_departement": "13",
    "nom_departement": "Bouches-du-Rhône",
    "full_departement": "13 | Bouches-du-Rhône"
  },
  {
    "id_departement": 14,
    "num_departement": "14",
    "nom_departement": "Calvados",
    "full_departement": "14 | Calvados"
  },
  {
    "id_departement": 15,
    "num_departement": "15",
    "nom_departement": "Cantal",
    "full_departement": "15 | Cantal"
  },
  {
    "id_departement": 16,
    "num_departement": "16",
    "nom_departement": "Charente",
    "full_departement": "16 | Charente"
  },
  {
    "id_departement": 17,
    "num_departement": "17",
    "nom_departement": "Charente-Maritime",
    "full_departement": "17 | Charente-Maritime"
  },
  {
    "id_departement": 18,
    "num_departement": "18",
    "nom_departement": "Cher",
    "full_departement": "18 | Cher"
  },
  {
    "id_departement": 19,
    "num_departement": "19",
    "nom_departement": "Corrèze",
    "full_departement": "19 | Corrèze"
  },
  {
    "id_departement": 20,
    "num_departement": "20",
    "nom_departement": "Corse",
    "full_departement": "20 | Corse"
  },
  {
    "id_departement": 21,
    "num_departement": "21",
    "nom_departement": "Côte d'or",
    "full_departement": "21 | Côte d'or"
  },
  {
    "id_departement": 22,
    "num_departement": "22",
    "nom_departement": "Côtes d'Armor",
    "full_departement": "22 | Côtes d'Armor"
  },
  {
    "id_departement": 23,
    "num_departement": "23",
    "nom_departement": "Creuse",
    "full_departement": "23 | Creuse"
  },
  {
    "id_departement": 24,
    "num_departement": "24",
    "nom_departement": "Dordogne",
    "full_departement": "24 | Dordogne"
  },
  {
    "id_departement": 25,
    "num_departement": "25",
    "nom_departement": "Doubs",
    "full_departement": "25 | Doubs"
  },
  {
    "id_departement": 26,
    "num_departement": "26",
    "nom_departement": "Drôme",
    "full_departement": "26 | Drôme"
  },
  {
    "id_departement": 27,
    "num_departement": "27",
    "nom_departement": "Eure",
    "full_departement": "27 | Eure"
  },
  {
    "id_departement": 28,
    "num_departement": "28",
    "nom_departement": "Eure-et-Loir",
    "full_departement": "28 | Eure-et-Loir"
  },
  {
    "id_departement": 29,
    "num_departement": "29",
    "nom_departement": "Finistère",
    "full_departement": "29 | Finistère"
  },
  {
    "id_departement": 30,
    "num_departement": "30",
    "nom_departement": "Gard",
    "full_departement": "30 | Gard"
  },
  {
    "id_departement": 31,
    "num_departement": "31",
    "nom_departement": "Haute garonne",
    "full_departement": "31 | Haute garonne"
  },
  {
    "id_departement": 32,
    "num_departement": "32",
    "nom_departement": "Gers",
    "full_departement": "32 | Gers"
  },
  {
    "id_departement": 33,
    "num_departement": "33",
    "nom_departement": "Gironde",
    "full_departement": "33 | Gironde"
  },
  {
    "id_departement": 34,
    "num_departement": "34",
    "nom_departement": "Hérault",
    "full_departement": "34 | Hérault"
  },
  {
    "id_departement": 35,
    "num_departement": "35",
    "nom_departement": "Ille-et-Vilaine",
    "full_departement": "35 | Ille-et-Vilaine"
  },
  {
    "id_departement": 36,
    "num_departement": "36",
    "nom_departement": "Indre",
    "full_departement": "36 | Indre"
  },
  {
    "id_departement": 37,
    "num_departement": "37",
    "nom_departement": "Indre-et-Loire",
    "full_departement": "37 | Indre-et-Loire"
  },
  {
    "id_departement": 38,
    "num_departement": "38",
    "nom_departement": "Isère",
    "full_departement": "38 | Isère"
  },
  {
    "id_departement": 39,
    "num_departement": "39",
    "nom_departement": "Jura",
    "full_departement": "39 | Jura"
  },
  {
    "id_departement": 40,
    "num_departement": "40",
    "nom_departement": "Landes",
    "full_departement": "40 | Landes"
  },
  {
    "id_departement": 41,
    "num_departement": "41",
    "nom_departement": "Loir-et-Cher",
    "full_departement": "41 | Loir-et-Cher"
  },
  {
    "id_departement": 42,
    "num_departement": "42",
    "nom_departement": "Loire",
    "full_departement": "42 | Loire"
  },
  {
    "id_departement": 43,
    "num_departement": "43",
    "nom_departement": "Haute loire",
    "full_departement": "43 | Haute loire"
  },
  {
    "id_departement": 44,
    "num_departement": "44",
    "nom_departement": "Loire-Atlantique",
    "full_departement": "44 | Loire-Atlantique"
  },
  {
    "id_departement": 45,
    "num_departement": "45",
    "nom_departement": "Loiret",
    "full_departement": "45 | Loiret"
  },
  {
    "id_departement": 46,
    "num_departement": "46",
    "nom_departement": "Lot",
    "full_departement": "46 | Lot"
  },
  {
    "id_departement": 47,
    "num_departement": "47",
    "nom_departement": "Lot et Garonne",
    "full_departement": "47 | Lot et Garonne"
  },
  {
    "id_departement": 48,
    "num_departement": "48",
    "nom_departement": "Lozère",
    "full_departement": "48 | Lozère"
  },
  {
    "id_departement": 49,
    "num_departement": "49",
    "nom_departement": "Maine et Loire",
    "full_departement": "49 | Maine et Loire"
  },
  {
    "id_departement": 50,
    "num_departement": "50",
    "nom_departement": "Manche",
    "full_departement": "50 | Manche"
  },
  {
    "id_departement": 51,
    "num_departement": "51",
    "nom_departement": "Marne",
    "full_departement": "51 | Marne"
  },
  {
    "id_departement": 52,
    "num_departement": "52",
    "nom_departement": "Haute Marne",
    "full_departement": "52 | Haute Marne"
  },
  {
    "id_departement": 53,
    "num_departement": "53",
    "nom_departement": "Mayenne",
    "full_departement": "53 | Mayenne"
  },
  {
    "id_departement": 54,
    "num_departement": "54",
    "nom_departement": "Meurthe et Moselle",
    "full_departement": "54 | Meurthe et Moselle"
  },
  {
    "id_departement": 55,
    "num_departement": "55",
    "nom_departement": "Meuse",
    "full_departement": "55 | Meuse"
  },
  {
    "id_departement": 56,
    "num_departement": "56",
    "nom_departement": "Morbihan",
    "full_departement": "56 | Morbihan"
  },
  {
    "id_departement": 57,
    "num_departement": "57",
    "nom_departement": "Moselle",
    "full_departement": "57 | Moselle"
  },
  {
    "id_departement": 58,
    "num_departement": "58",
    "nom_departement": "Nièvre",
    "full_departement": "58 | Nièvre"
  },
  {
    "id_departement": 59,
    "num_departement": "59",
    "nom_departement": "Nord",
    "full_departement": "59 | Nord"
  },
  {
    "id_departement": 60,
    "num_departement": "60",
    "nom_departement": "Oise",
    "full_departement": "60 | Oise"
  },
  {
    "id_departement": 61,
    "num_departement": "61",
    "nom_departement": "Orne",
    "full_departement": "61 | Orne"
  },
  {
    "id_departement": 62,
    "num_departement": "62",
    "nom_departement": "Pas de Calais",
    "full_departement": "62 | Pas de Calais"
  },
  {
    "id_departement": 63,
    "num_departement": "63",
    "nom_departement": "Puy de Dôme",
    "full_departement": "63 | Puy de Dôme"
  },
  {
    "id_departement": 64,
    "num_departement": "64",
    "nom_departement": "Pyrénées Atlantiques",
    "full_departement": "64 | Pyrénées Atlantiques"
  },
  {
    "id_departement": 65,
    "num_departement": "65",
    "nom_departement": "Hautes Pyrénées",
    "full_departement": "65 | Hautes Pyrénées"
  },
  {
    "id_departement": 66,
    "num_departement": "66",
    "nom_departement": "Pyrénées Orientales",
    "full_departement": "66 | Pyrénées Orientales"
  },
  {
    "id_departement": 67,
    "num_departement": "67",
    "nom_departement": "Bas Rhin",
    "full_departement": "67 | Bas Rhin"
  },
  {
    "id_departement": 68,
    "num_departement": "68",
    "nom_departement": "Haut Rhin",
    "full_departement": "68 | Haut Rhin"
  },
  {
    "id_departement": 69,
    "num_departement": "69",
    "nom_departement": "Rhône",
    "full_departement": "69 | Rhône"
  },
  {
    "id_departement": 70,
    "num_departement": "70",
    "nom_departement": "Haute Saône",
    "full_departement": "70 | Haute Saône"
  },
  {
    "id_departement": 71,
    "num_departement": "71",
    "nom_departement": "Saône et Loire",
    "full_departement": "71 | Saône et Loire"
  },
  {
    "id_departement": 72,
    "num_departement": "72",
    "nom_departement": "Sarthe",
    "full_departement": "72 | Sarthe"
  },
  {
    "id_departement": 73,
    "num_departement": "73",
    "nom_departement": "Savoie",
    "full_departement": "73 | Savoie"
  },
  {
    "id_departement": 74,
    "num_departement": "74",
    "nom_departement": "Haute Savoie",
    "full_departement": "74 | Haute Savoie"
  },
  {
    "id_departement": 75,
    "num_departement": "75",
    "nom_departement": "Paris",
    "full_departement": "75 | Paris"
  },
  {
    "id_departement": 76,
    "num_departement": "76",
    "nom_departement": "Seine Maritime",
    "full_departement": "76 | Seine Maritime"
  },
  {
    "id_departement": 77,
    "num_departement": "77",
    "nom_departement": "Seine-et-Marne",
    "full_departement": "77 | Seine-et-Marne"
  },
  {
    "id_departement": 78,
    "num_departement": "78",
    "nom_departement": "Yvelines",
    "full_departement": "78 | Yvelines"
  },
  {
    "id_departement": 79,
    "num_departement": "79",
    "nom_departement": "Deux Sèvres",
    "full_departement": "79 | Deux Sèvres"
  },
  {
    "id_departement": 80,
    "num_departement": "80",
    "nom_departement": "Somme",
    "full_departement": "80 | Somme"
  },
  {
    "id_departement": 81,
    "num_departement": "81",
    "nom_departement": "Tarn",
    "full_departement": "81 | Tarn"
  },
  {
    "id_departement": 82,
    "num_departement": "82",
    "nom_departement": "Tarn et Garonne",
    "full_departement": "82 | Tarn et Garonne"
  },
  {
    "id_departement": 83,
    "num_departement": "83",
    "nom_departement": "Var",
    "full_departement": "83 | Var"
  },
  {
    "id_departement": 84,
    "num_departement": "84",
    "nom_departement": "Vaucluse",
    "full_departement": "84 | Vaucluse"
  },
  {
    "id_departement": 85,
    "num_departement": "85",
    "nom_departement": "Vendée",
    "full_departement": "85 | Vendée"
  },
  {
    "id_departement": 86,
    "num_departement": "86",
    "nom_departement": "Vienne",
    "full_departement": "86 | Vienne"
  },
  {
    "id_departement": 87,
    "num_departement": "87",
    "nom_departement": "Haute Vienne",
    "full_departement": "87 | Haute Vienne"
  },
  {
    "id_departement": 88,
    "num_departement": "88",
    "nom_departement": "Vosges",
    "full_departement": "88 | Vosges"
  },
  {
    "id_departement": 89,
    "num_departement": "89",
    "nom_departement": "Yonne",
    "full_departement": "89 | Yonne"
  },
  {
    "id_departement": 90,
    "num_departement": "90",
    "nom_departement": "Territoire de Belfort",
    "full_departement": "90 | Territoire de Belfort"
  },
  {
    "id_departement": 91,
    "num_departement": "91",
    "nom_departement": "Essonne",
    "full_departement": "91 | Essonne"
  },
  {
    "id_departement": 92,
    "num_departement": "92",
    "nom_departement": "Hauts-de-Seine",
    "full_departement": "92 | Hauts-de-Seine"
  },
  {
    "id_departement": 93,
    "num_departement": "93",
    "nom_departement": "Seine-Saint-Denis",
    "full_departement": "93 | Seine-Saint-Denis"
  },
  {
    "id_departement": 94,
    "num_departement": "94",
    "nom_departement": "Val-de-Marne",
    "full_departement": "94 | Val-de-Marne"
  },
  {
    "id_departement": 95,
    "num_departement": "95",
    "nom_departement": "Val-d'Oise",
    "full_departement": "95 | Val-d'Oise"
  }
];
